module.exports = __webpack_public_path__ + "static/img/vip-icon1.e575b0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip-icon1.png
// module id = ALvb
// module chunks = 1